import { QUERY_KEYS } from "library/shared";
import { ITaxonomy } from "library/types";
import { useQuery, UseQueryResult } from "react-query";
import api from "service/api";

import useNotificationHandler from "hooks/useNotificationHandler";

const getTaxonomies = async () => {
  const response = await api.get(`/taxonomy`);

  return response.data;
};

export function useGetTaxonomies(enabled = true): UseQueryResult<ITaxonomy> {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  return useQuery<ITaxonomy, Error>(QUERY_KEYS.taxonomies, getTaxonomies, {
    enabled: enabled,
    refetchOnMount: false,
    onError: (error: any) => {
      handleAddAxiosErrorNotification(error);
    },
  });
}
